import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  setTheme(primary: string, secondary: string): void {
    document.documentElement.style.setProperty('--primary-color', primary);

    document.documentElement.style.setProperty('--secondary-color', secondary);
  }
}
